/**
 * CancellablePromise to extend the default Promise object to include a cancel method.
 */
export default class CancellablePromise {
	reject = null;
	cancelCB = null;

	constructor ( executor ) {
		this.promise = new Promise ( ( resolve, reject ) => {
			this.reject = reject;
			// pass our `onCancel` method as third parameter
			executor( resolve, reject, this.onCancel );
		} );
	}

	then () {
		// invoke the default `Promise` then method
		return this.promise.then.apply( this.promise, arguments );
	}

	catch () {
		// invoke the default `Promise` catch method
		return this.promise.catch.apply( this.promise, arguments );
	}

	cancel() {
		// If the `Promise` executor had set the `cancel` method, invoke it
		if ( this.cancelCB ) {
			this.cancelCB();
		}
		// Reject the promise to cancel it
		this.reject();
	}

	onCancel = ( callback ) => {
		// Set a reference to the callback method which we can invoke on cancel
		this.cancelCB = callback;
	};
}
